/**
 * Created by zjs on 2017/08/30
 */
import * as types from './mutation-types'

export default {
    /**
     * 更新登录标识
     */
    updateAuthorizd ({commit}, bool) {
        commit(types.UPDATE_AUTHORIZD, bool)
    },
    /**
     * tokon的更新
     */
    updateTokon ({commit}, tokon) {
        commit(types.UPDATE_TOKON, tokon)
    },
    /**
     * 初始化用户信息
     */
    initUserInfo ({commit}, info) {
        commit(types.INIT_USER_INFO, info)  
    }
}